'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import 'bootstrap';
import { modalSaveReport } from '../../modules/modalSaveReport.js';
import { closeModal } from '../../modules/modal.js';

const reportactivities = {
  init() {
    const $form = $('.js-form-activities');
    const $modal = $('#modal-save');

    modalSaveReport(validateFields);

    $form.on('submit', function (e) {
      e.preventDefault();

      if (validateFields()) e.target.submit();
    });

    $('.custom-control-input').on('change', function (e) {
      const $target = $('#' + $(this).attr('data-id'));

      if (this.value == 1) {
        $target.removeClass('u-display--none');
      } else {
        $target.addClass('u-display--none');
        $target.find('input, textarea').val('');
      }
    });

    function validateFields() {
      let isValid = true;

      if (!$("input[name='make_donation']").is(':checked')) {
        Swal.fire({
          icon: 'error',
          title: 'Atenção!',
          text: 'Informe se você fez doação!',
        });

        isValid = false;
      }

      if ($("input[name='make_donation']:checked").val() == 1) {
        $('#donation [required]').each(function (_index, el) {
          if (el.value.length <= 0) {
            Swal.fire({
              icon: 'error',
              title: 'Atenção!',
              text: 'Preencha os campos de doação corretamente',
            });

            isValid = false;
          }
        });
      }

      if (!$('input[name="activities[]"]').is(':checked')) {
        Swal.fire({
          icon: 'error',
          title: 'Atenção!',
          text: 'Preencha pelo menos 1 item de Atividade!',
        });

        isValid = false;
      }

      if (!isValid && $modal.length) closeModal('#modal-save');

      return isValid;
    }
  },
};

export default reportactivities;
